export const hasValidToken = (token) => {
  if (!token) {
    return false;
  }

  if (typeof token === "string") {
    return token.trim().length > 0;
  }

  if (typeof token === "object") {
    if (typeof token.token === "string") {
      return token.token.trim().length > 0;
    }

    if (typeof token.accessToken === "string") {
      return token.accessToken.trim().length > 0;
    }

    return Object.keys(token).length > 0;
  }

  return false;
};

export const getStoredUserId = (user) => {
  return user?.userId || user?.id || "";
};

export const readStoredToken = () => {
  const raw = localStorage.getItem("token");
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return raw;
  }
};

export const isLoggedInUserInfo = (userInformation) => {
  return Boolean(
    userInformation?.isLoggedIn === true && getStoredUserId(userInformation),
  );
};

export const isAuthenticatedUser = (user, token) => {
  return Boolean(getStoredUserId(user) && hasValidToken(token));
};

export const isVendorUser = (userInformation) => {
  return Boolean(
    isLoggedInUserInfo(userInformation) &&
    userInformation?.userType === "vendor",
  );
};
